import { ReportBetMobileType } from "app/types/reportType";
import { BetFormats } from "app/utils/const";
import Report from "../Report";

type Props = {
  bet: ReportBetMobileType;
  index: number;
  tab: string;
};
const SettledBet: React.FC<Props> = ({ bet, index, tab }) => {
  const marketName = bet.marketName;

  const betType = bet.betType?.betType;
  const translatedBetType = bet.betType?.translatedBetType;

  const eventName =
    betType === BetFormats.BET_BUILDER
      ? bet?.legs[0]?.eventName
      : bet.selection?.event || "";

  return (
    <Report
      bet={bet}
      marketName={marketName}
      eventName={eventName}
      contentType={tab}
      key={index}
      translatedBetType={translatedBetType}
      betType={betType}
    />
  );
};

export default SettledBet;
